export function formatPhoneNumber(phone?: string) {
  if (!phone) {
    return '';
  }

  return phone.replace(/ /g, '').replace(/^(\d{3})(\d{3})(\d{4})$/, '$1 $2 $3');
}
